import React, { useState, useEffect } from 'react';
import axios from '../axios';
import { StepNavigation as StepType } from '../types/Template';
import { ParentShelf, ChildShelf, Content } from '../types/Template';
import { useFilterGuarantor } from '../hooks/Guarantor';
import { ShelfInfo } from '../types/FileUpload';
import { init_shelfs } from '../const/FileUpload';
import { step_init, agreements_init, guarantor_init, contract_info_int } from '../Const';
import { handleBrowserBack } from '../BrowserBack';

/**
 * 詳細画面に表示するための情報を取得する
 */
const useFetchReceptionData = (setIsLoading: React.Dispatch<React.SetStateAction<boolean>>) => {
  // ヘッダ
  const [label, setLabel] = useState('');
  const [guide_text, setGuideText] = useState([]);
  const [step_navigation, setStepNavigation] = useState<StepType>(step_init);
  const [display_reception_cd, setDisplayReceptionCd] = useState(false);
  const [display_status, setDisplayStatus] = useState(true);
  // 詳細画面情報
  const [parent_shelfs, setParentShelfs] = useState<ParentShelf[]>([]);
  const [child_shelfs, setChildShelfs] = useState<ChildShelf[]>([]);
  const [contents, setContents] = useState<Content[]>([]);
  // 固定パラメータ
  const [status_name, setStatusName] = useState('');
  const [status_code, setStatusCode] = useState(0);
  const [loan_type, setLoanType] = useState('');
  const [reception_id, setReceptionId] = useState(0);
  const [reception_cd, setReceptionCd] = useState('');
  const [reception_sub_cd, setReceptionSubCd] = useState('');
  const [ident_lv1_cd, setIdentLv1Cd] = useState('');
  const [ident_lv2_cd, setIdentLv2Cd] = useState('');
  const [ident_lv3_cd, setIdentLv3Cd] = useState('');
  const [ja_name, setJaName] = useState('');
  const [opened_mypage, setMypageOpened] = useState(false);
  const [is_staff, setIsStaff] = useState(false);
  const [applied, setApplied] = useState(false);
  const [is_change, setisChange] = useState(false);
  const [has_debtor, sethasDebtor] = useState(false);
  const [is_disagree, setIsDisagree] = useState(false);
  const [change_request_message, setChangeRequestMessage] = useState('');
  const [is_change_request_message_registered, setIsChangeRequestMessageRegistered] = useState(
    false
  );
  const [guarantors_num, setGuarantorsNum] = useFilterGuarantor(contents);
  const [guarantor_info, setGuarantorInfo] = useState(guarantor_init);
  const [review_approval_status, setReviewApprovalStatus] = useState(false);
  const [review_message, setReviewMessage] = useState('');
  const [has_loan_approval, setHasLoanApproval] = useState(true);
  const [mp_flg, setMpflg] = useState(0);
  const [ma_flg, setMaflg] = useState(0);
  const [is_implement_online_identification, setIsImplementOnlineIdentification] = useState(false);
  const [has_hosho_flg, setHasHoshoFlg] = useState(false);
  const [is_guarantor_agreement, setIsGuarantorAgreement] = useState(false);
  const [is_mypage_ja, setIsMypageJA] = useState(false);
  // 署名情報
  const [sign_info, setSignInfo] = useState([]);
  const [is_signed, setIsSigned] = useState(false);
  // 同意情報
  const [agreement_info, setAgreementInfo] = useState([]);
  const [agreements, setAgreements] = useState(agreements_init);
  // 契約情報
  const [contract_info, setContractInfo] = useState(contract_info_int);
  // 保証期間連携済みフラグ
  const [is_sent_to_guaranty_company, setIsSentToGuarantyCompany] = useState(false);
  // csvダウンロード済みフラグ
  const [is_csv_downloaded, setIsCsvDownloaded] = useState(false);
  // 管理店に表示する支店のリスト
  const [office_list, setOfficeList] = useState([]);
  // お取引希望店舗アコーディオンの取引店が存在してるかのフラグ
  const [is_desired_bank_exists, setDesiredBankExists] = useState(true);
  // 口座情報アコーディオンの取引店が存在してるかのフラグ
  const [is_bank_exists, setBankExists] = useState(true);
  // JAコードに紐づくJAが存在するかのフラグ
  const [is_ja_exists, setJaExists] = useState(true);
  const [management_store_cd, setManagementStoreCd] = useState('');
  // 職員画面で表示する同意事項、保証機関、事前審査結果の表示データ
  const [review_approval_status_name, setReviewApprovalStatusName] = useState('');
  const [
    guarantee_agency_examination_result_name,
    setGuaranteeAgencyExaminationResultName,
  ] = useState('');
  const [consent_datetime_privacy, setConsentDatetimeprivacy] = useState('');
  const [consent_datetime_not_antisocial_forces, setConsentDatetimeNotAntisocialForces] = useState(
    ''
  );
  const [suspicious_irregularity_flg, setSuspiciousIrregularityFlg] = useState(false);
  // 契約書内容確認　書類確認ステータス
  const [is_checked_contract_document, setIsCheckedContractDocument] = useState(false);
  // 本人確認実施中のダイアログ管理
  const [online_identification_modal_open, setOnlineIdentificationModalOpen] = useState(false);
  //農業資金借入申込種別が農業資金借入申込かのフラグ
  const [
    is_agricultural_funds_kinds_agricultural_fund,
    setIsAgriculturalFundsKindsAgriculturalFund,
  ] = useState(false);
  // 農業資金借入申込種別が近代化資金➀ or 近代化資金➁かのフラグ
  const [
    is_agricultural_funds_kinds_modernization_fund,
    isAgriculturalFundsKindsModernizationFund,
  ] = useState(false);
  // 近代化資金_借入申込が変更中か否か
  const [is_change_modernization_funds, isChangeModernizationFunds] = useState(false);
  // 借入申込希望書兼経営改善資金計画書が変更中か否か
  const [
    is_change_business_improvement_financing_plan,
    isChangeBusinessImprovementFinancingPlan,
  ] = useState(false);
  // 有担保か否か
  const [is_secured, setIsSecured] = useState(false);
  // 無担保か否か
  const [is_unsecured, setIsUnsecured] = useState(false);
  // 農業資金・近代化資金か否か
  const [is_agricultural_modernization_funds, setIsAgriculturalModernizationFunds] = useState(
    false
  );
  // 法人ユーザーか否か
  const [is_corporate_user, setIsCorporateUser] = useState(false);
  // ファイルアップローダ関連
  const [shelf_info_a, setShelfInfoA] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_b, setShelfInfoB] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_c, setShelfInfoC] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_d, setShelfInfoD] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_e, setShelfInfoE] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_f, setShelfInfoF] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_g, setShelfInfoG] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_h, setShelfInfoH] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_i, setShelfInfoI] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_j, setShelfInfoJ] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_k, setShelfInfoK] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_aa, setShelfInfoAA] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ab, setShelfInfoAB] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ac, setShelfInfoAC] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ad, setShelfInfoAD] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ae, setShelfInfoAE] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_af, setShelfInfoAF] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ag, setShelfInfoAG] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ah, setShelfInfoAH] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ai, setShelfInfoAI] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_aj, setShelfInfoAJ] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ak, setShelfInfoAK] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_al, setShelfInfoAL] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_am, setShelfInfoAM] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_an, setShelfInfoAN] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ao, setShelfInfoAO] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ap, setShelfInfoAP] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_aq, setShelfInfoAQ] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ar, setShelfInfoAR] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_as, setShelfInfoAS] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_at, setShelfInfoAT] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_au, setShelfInfoAU] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_av, setShelfInfoAV] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_aw, setShelfInfoAW] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ax, setShelfInfoAX] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ay, setShelfInfoAY] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_az, setShelfInfoAZ] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_ba, setShelfInfoBA] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_bb, setShelfInfoBB] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_bc, setShelfInfoBC] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_bd, setShelfInfoBD] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_be, setShelfInfoBE] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_bf, setShelfInfoBF] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_bg, setShelfInfoBG] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_bh, setShelfInfoBH] = useState<ShelfInfo>({ ...init_shelfs });
  const [shelf_info_bi, setShelfInfoBI] = useState<ShelfInfo>({ ...init_shelfs });
  // お客様へのお知らせ
  const [info_notice_contract_confirm, setInfoNoticeContractConfirm] = useState('');
  // 辞退ボタンの活性フラグ
  const [is_active_decline_btn, setIsActiveDeclineBtn] = useState(true);
  // しっかり審査から「借入申込をする」ボタン押下のフラグ
  const [on_loan_application_button_clicked, setOnLoanApplicationButtonClicked] = useState(false);
  // 署名対象か否か(契約書を表示するボタンの表示フラグ)
  const [is_signer, setIsSigner] = useState(false);

  /**
   * テンプレート取得用のパスを生成する
   *
   * @return string テンプレート取得URL
   */
  const makePath = (): string => {
    const reception_cd = document.getElementById('reception_cd')?.getAttribute('reception_cd');
    const reception_id = document.getElementById('reception_id')?.getAttribute('reception_id');
    return `${location.origin}${process.env.MIX_MOCK_URL}/api/reception/${reception_cd}/${reception_id}${location.search}`;
  };

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    fetchReception(makePath());
    setIsLoading(true);
  }, []);

  /**
   * 案件詳細画面表示に必要なデータを再取得します。
   * エラー発生時はローディングを非表示にします。
   * @param url データ取得先url
   */
  const fetchReception = async (url: string) => {
    try {
      const response = await axios.get(url);
      // ヘッダ
      setLabel(response.data.info.fixed_values.page_heading_label);
      setStatusName(response.data.info.fixed_values.status_name);
      setGuideText(response.data.info.fixed_values.page_heading_guidetext);
      setStepNavigation(response.data.info.fixed_values.page_heading_stepnavigation);
      setDisplayReceptionCd(response.data.info.fixed_values.display_reception_cd);
      setDisplayStatus(response.data.info.fixed_values.display_status);
      // 動的生成画面
      setContents(response.data.info.contents);
      setParentShelfs(response.data.info.parent_blocks);
      setChildShelfs(response.data.info.child_blocks);
      // 各種パラメータ
      setReceptionId(response.data.info.fixed_values.reception_id);
      setReceptionCd(response.data.info.fixed_values.reception_cd);
      setReceptionSubCd(response.data.info.fixed_values.reception_sub_cd);
      setIdentLv1Cd(response.data.info.fixed_values.ident_lv1_cd);
      setIdentLv2Cd(response.data.info.fixed_values.ident_lv2_cd);
      setIdentLv3Cd(response.data.info.fixed_values.ident_lv3_cd);
      setStatusName(response.data.info.fixed_values.status_name);
      setStatusCode(response.data.info.fixed_values.status_code);
      setLoanType(response.data.info.fixed_values.loan_type);
      setJaName(response.data.info.fixed_values.ja_name);
      setMypageOpened(response.data.info.fixed_values.opened_mypage);
      setIsStaff(response.data.info.fixed_values.is_staff);
      setApplied(response.data.info.fixed_values.applied);
      setisChange(response.data.info.fixed_values.is_change);
      sethasDebtor(response.data.info.fixed_values.has_debtor);
      setIsDisagree(response.data.info.fixed_values.is_disagree);
      setChangeRequestMessage(response.data.info.fixed_values.change_request_message);
      setIsChangeRequestMessageRegistered(
        response.data.info.fixed_values.is_change_request_message_registered
      );
      setGuarantorsNum(response.data.info.fixed_values.guarantors_num);
      setGuarantorInfo(response.data.info.guarantor_info);
      setReviewApprovalStatus(response.data.info.fixed_values.review_approval_status);
      setIsSentToGuarantyCompany(response.data.info.fixed_values.is_sent_to_guaranty_company);
      setIsCsvDownloaded(response.data.info.fixed_values.is_csv_downloaded);
      setOfficeList(response.data.info.fixed_values.office_list);
      setDesiredBankExists(response.data.info.fixed_values.is_desired_bank_exists);
      setBankExists(response.data.info.fixed_values.is_bank_exists);
      setJaExists(response.data.info.fixed_values.is_ja_exists);
      setManagementStoreCd(response.data.info.fixed_values.management_store_cd);
      setReviewApprovalStatusName(response.data.info.fixed_values.review_approval_status_name);
      setReviewMessage(response.data.info.fixed_values.review_message);
      setGuaranteeAgencyExaminationResultName(
        response.data.info.fixed_values.guarantee_agency_examination_result_name
      );
      setConsentDatetimeprivacy(response.data.info.fixed_values.consent_datetime_privacy);
      setConsentDatetimeNotAntisocialForces(
        response.data.info.fixed_values.consent_datetime_not_antisocial_forces
      );
      setSuspiciousIrregularityFlg(response.data.info.fixed_values.suspicious_irregularity_flg);
      setIsCheckedContractDocument(response.data.info.fixed_values.is_checked_contract_document);
      setHasLoanApproval(response.data.info.fixed_values.has_loan_approval);
      setHasHoshoFlg(response.data.info.fixed_values.has_hosho_flg);
      setIsMypageJA(response.data.info.fixed_values.is_mypage_ja);
      setMpflg(response.data.info.fixed_values.mp_flg);
      setMaflg(response.data.info.fixed_values.ma_flg);
      setIsAgriculturalFundsKindsAgriculturalFund(
        response.data.info.fixed_values.is_agricultural_funds_kinds_agricultural_fund
      );
      isAgriculturalFundsKindsModernizationFund(
        response.data.info.fixed_values.is_agricultural_funds_kinds_modernization_fund
      );
      isChangeModernizationFunds(response.data.info.fixed_values.is_change_modernization_funds);
      isChangeBusinessImprovementFinancingPlan(
        response.data.info.fixed_values.is_change_business_improvement_financing_plan
      );
      setIsSecured(response.data.info.fixed_values.is_secured);
      setIsUnsecured(response.data.info.fixed_values.is_unsecured);
      setIsAgriculturalModernizationFunds(
        response.data.info.fixed_values.is_agricultural_modernization_funds
      );
      // ファイルアップローダ
      setShelfInfoA(response.data.info.files.file_data.A);
      setShelfInfoB(response.data.info.files.file_data.B);
      setShelfInfoC(response.data.info.files.file_data.C);
      setShelfInfoD(response.data.info.files.file_data.D);
      setShelfInfoE(response.data.info.files.file_data.E);
      setShelfInfoF(response.data.info.files.file_data.F);
      setShelfInfoG(response.data.info.files.file_data.G);
      setShelfInfoH(response.data.info.files.file_data.H);
      setShelfInfoI(response.data.info.files.file_data.I);
      setShelfInfoJ(response.data.info.files.file_data.J);
      setShelfInfoK(response.data.info.files.file_data.K);
      setShelfInfoAA(response.data.info.files.file_data.AA);
      setShelfInfoAB(response.data.info.files.file_data.AB);
      setShelfInfoAC(response.data.info.files.file_data.AC);
      setShelfInfoAD(response.data.info.files.file_data.AD);
      setShelfInfoAE(response.data.info.files.file_data.AE);
      setShelfInfoAF(response.data.info.files.file_data.AF);
      setShelfInfoAG(response.data.info.files.file_data.AG);
      setShelfInfoAH(response.data.info.files.file_data.AH);
      setShelfInfoAI(response.data.info.files.file_data.AI);
      setShelfInfoAJ(response.data.info.files.file_data.AJ);
      setShelfInfoAK(response.data.info.files.file_data.AK);
      setShelfInfoAL(response.data.info.files.file_data.AL);
      setShelfInfoAM(response.data.info.files.file_data.AM);
      setShelfInfoAN(response.data.info.files.file_data.AN);
      setShelfInfoAO(response.data.info.files.file_data.AO);
      setShelfInfoAP(response.data.info.files.file_data.AP);
      setShelfInfoAQ(response.data.info.files.file_data.AQ);
      setShelfInfoAR(response.data.info.files.file_data.AR);
      setShelfInfoAS(response.data.info.files.file_data.AS);
      setShelfInfoAT(response.data.info.files.file_data.AT);
      setShelfInfoAU(response.data.info.files.file_data.AU);
      setShelfInfoAV(response.data.info.files.file_data.AV);
      setShelfInfoAW(response.data.info.files.file_data.AW);
      setShelfInfoAX(response.data.info.files.file_data.AX);
      setShelfInfoAY(response.data.info.files.file_data.AY);
      setShelfInfoAZ(response.data.info.files.file_data.AZ);
      setShelfInfoBA(response.data.info.files.file_data.BA);
      setShelfInfoBB(response.data.info.files.file_data.BB);
      setShelfInfoBC(response.data.info.files.file_data.BC);
      setShelfInfoBD(response.data.info.files.file_data.BD);
      setShelfInfoBE(response.data.info.files.file_data.BE);
      setShelfInfoBF(response.data.info.files.file_data.BF);
      setShelfInfoBG(response.data.info.files.file_data.BG);
      setShelfInfoBH(response.data.info.files.file_data.BH);
      setShelfInfoBI(response.data.info.files.file_data.BI);
      // 署名情報
      setSignInfo(response.data.info.sign_info);
      setIsSigned(response.data.info.fixed_values.is_signed);
      // 同意情報
      setAgreementInfo(response.data.info.agreement_info);
      setAgreements(response.data.info.agreements);
      // 契約情報
      setContractInfo(response.data.info.contract_info);
      // お客様へのお知らせ
      setInfoNoticeContractConfirm(response.data.info.info_notice_contract_confirm);
      // 辞退ボタンの活性フラグ
      setIsActiveDeclineBtn(response.data.info.is_active_decline_btn);
      setIsCorporateUser(response.data.info.fixed_values.is_corporate_user);
      // 署名対象か否か(契約書を表示するボタンの表示フラグ)
      setIsSigner(response.data.info.fixed_values.is_signer);
    } catch (error) {
      console.error(error);
      // エラーメッセージを表示後、案件一覧に遷移する
      alert(error.response.data.message);
      location.replace(`${location.origin}${process.env.MIX_MOCK_URL}`);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * ステップナビゲーションの強調位置を移動する
   */
  const moveStepNav = (next_current: number) => {
    setStepNavigation(prev => {
      return { ...prev, current: next_current };
    });
  };

  // 詳細画面表示に必要な値を返却する
  return {
    // ヘッダ
    label,
    guide_text,
    step_navigation,
    display_reception_cd,
    display_status,
    // 詳細画面情報
    parent_shelfs,
    child_shelfs,
    contents,
    // 固定パラメータ
    status_name,
    status_code,
    loan_type,
    reception_id,
    reception_cd,
    reception_sub_cd,
    ident_lv1_cd,
    ident_lv2_cd,
    ident_lv3_cd,
    ja_name,
    opened_mypage,
    is_staff,
    applied,
    is_change,
    has_debtor,
    is_disagree,
    change_request_message,
    guarantors_num,
    sign_info,
    agreement_info,
    is_signed,
    agreements,
    guarantor_info,
    review_approval_status,
    contract_info,
    is_sent_to_guaranty_company,
    is_csv_downloaded,
    office_list,
    is_bank_exists,
    is_ja_exists,
    management_store_cd,
    review_approval_status_name,
    review_message,
    guarantee_agency_examination_result_name,
    consent_datetime_privacy,
    consent_datetime_not_antisocial_forces,
    suspicious_irregularity_flg,
    is_checked_contract_document,
    has_loan_approval,
    has_hosho_flg,
    is_mypage_ja,
    mp_flg,
    ma_flg,
    is_change_request_message_registered,
    is_implement_online_identification,
    online_identification_modal_open,
    is_agricultural_funds_kinds_agricultural_fund,
    is_agricultural_funds_kinds_modernization_fund,
    is_guarantor_agreement,
    is_desired_bank_exists,
    is_change_modernization_funds,
    is_change_business_improvement_financing_plan,
    is_secured,
    is_unsecured,
    is_agricultural_modernization_funds,
    // ファイルアップローダ
    shelf_info_a,
    shelf_info_b,
    shelf_info_c,
    shelf_info_d,
    shelf_info_e,
    shelf_info_f,
    shelf_info_g,
    shelf_info_h,
    shelf_info_i,
    shelf_info_j,
    shelf_info_k,
    shelf_info_aa,
    shelf_info_ab,
    shelf_info_ac,
    shelf_info_ad,
    shelf_info_ae,
    shelf_info_af,
    shelf_info_ag,
    shelf_info_ah,
    shelf_info_ai,
    shelf_info_aj,
    shelf_info_ak,
    shelf_info_al,
    shelf_info_am,
    shelf_info_an,
    shelf_info_ao,
    shelf_info_ap,
    shelf_info_aq,
    shelf_info_ar,
    shelf_info_as,
    shelf_info_at,
    shelf_info_au,
    shelf_info_av,
    shelf_info_aw,
    shelf_info_ax,
    shelf_info_ay,
    shelf_info_az,
    shelf_info_ba,
    shelf_info_bb,
    shelf_info_bc,
    shelf_info_bd,
    shelf_info_be,
    shelf_info_bf,
    shelf_info_bg,
    shelf_info_bh,
    shelf_info_bi,
    // お客様へのお知らせ
    info_notice_contract_confirm,
    // 辞退ボタンの活性フラグ
    is_active_decline_btn,
    is_corporate_user,
    // しっかり審査から「借入申込をする」ボタン押下のフラグ
    on_loan_application_button_clicked,
    // 署名対象か否か(契約書を表示するボタンの表示フラグ)
    is_signer,
    setOnLoanApplicationButtonClicked,
    // ディスパッチ
    setParentShelfs,
    setChildShelfs,
    setContents,
    setShelfInfoA,
    setShelfInfoB,
    setShelfInfoC,
    setShelfInfoD,
    setShelfInfoE,
    setShelfInfoF,
    setShelfInfoG,
    setShelfInfoH,
    setShelfInfoI,
    setShelfInfoJ,
    setShelfInfoK,
    setShelfInfoAA,
    setShelfInfoAB,
    setShelfInfoAC,
    setShelfInfoAD,
    setShelfInfoAE,
    setShelfInfoAF,
    setShelfInfoAG,
    setShelfInfoAH,
    setShelfInfoAI,
    setShelfInfoAJ,
    setShelfInfoAK,
    setShelfInfoAL,
    setShelfInfoAM,
    setShelfInfoAN,
    setShelfInfoAO,
    setShelfInfoAP,
    setShelfInfoAQ,
    setShelfInfoAR,
    setShelfInfoAS,
    setShelfInfoAT,
    setShelfInfoAU,
    setShelfInfoAV,
    setShelfInfoAW,
    setShelfInfoAX,
    setShelfInfoAY,
    setShelfInfoAZ,
    setShelfInfoBA,
    setShelfInfoBB,
    setShelfInfoBC,
    setShelfInfoBD,
    setShelfInfoBE,
    setShelfInfoBF,
    setShelfInfoBG,
    setShelfInfoBH,
    setShelfInfoBI,
    setDisplayReceptionCd,
    setDisplayStatus,
    setIsImplementOnlineIdentification,
    setIsGuarantorAgreement,
    // 関数
    moveStepNav,
    setManagementStoreCd,
    setLabel,
    setStepNavigation,
    fetchReception,
    setOnlineIdentificationModalOpen,
  };
};

export default useFetchReceptionData;
